import { render, staticRenderFns } from "./safetyControlDangerous.vue?vue&type=template&id=38783992"
import script from "./safetyControlDangerous.vue?vue&type=script&lang=js"
export * from "./safetyControlDangerous.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38783992')) {
      api.createRecord('38783992', component.options)
    } else {
      api.reload('38783992', component.options)
    }
    module.hot.accept("./safetyControlDangerous.vue?vue&type=template&id=38783992", function () {
      api.rerender('38783992', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chm/law/safetyControlDangerous.vue"
export default component.exports